module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category"
  }, [_c('div', {
    staticClass: "category-info"
  }, [_c('h1', [_vm._v(_vm._s((_vm.category && _vm.category.name)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s((_vm.category && _vm.category.description)))])]), _vm._v(" "), _c('app-videos', {
    attrs: {
      "videos": _vm.videos
    }
  }), _vm._v(" "), (this.user && _vm.category.hasQuestionnaire) ? _c('div', [_c('h2', {
    attrs: {
      "id": "documents"
    }
  }, [_vm._v("Questionnaire")]), _vm._v(" "), (_vm.category) ? _c('div', {
    staticClass: "questionnaire"
  }, [(_vm.validCategory(_vm.category.id)[0] === 'none') ? _c('button', {
    staticClass: "questionnaire-button",
    on: {
      "click": function($event) {
        return _vm.startQuestionnaire()
      }
    }
  }, [_vm._v("Commencer le quiz")]) : _c('div', [_c('p', [_vm._v("Vous avez déjà complété cette catégorie.")]), _vm._v(" "), _c('button', {
    staticClass: "questionnaire-button",
    on: {
      "click": function($event) {
        return _vm.showResults()
      }
    }
  }, [_vm._v(" Résultats")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showQuestionnaire) ? _c('div', [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container quizz",
    attrs: {
      "id": "quizz"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('h2', [_vm._v("Questionnaire : " + _vm._s(_vm.category.name))]), _vm._v(" "), _c('form', _vm._l((_vm.questionnaire), function(q, idx) {
    return _c('div', {
      key: idx,
      class: [{
        'none': q.state === 0 && idx % 2 === 0
      }, {
        'none-2': q.state === 0 && idx % 2 === 1
      }, {
        'false': q.state === 1
      }, {
        'right': q.state === 2
      }],
      staticStyle: {
        "height": "160px"
      },
      attrs: {
        "id": "main"
      }
    }, [_c('div', {
      staticClass: "text"
    }, [(q.type === 1) ? _c('h3', [_vm._v("Q." + _vm._s(idx + 1) + " " + _vm._s(q.content))]) : _vm._e(), _vm._v(" "), (q.type !== 1) ? _c('h3', [_vm._v("Q." + _vm._s(idx + 1) + " " + _vm._s(q.content) + " "), _c('br'), _vm._v("Plusieurs réponses peuvent être cochées")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "answer"
    }, [_c('table', [_c('tr', _vm._l((q.answers), function(answer) {
      return _c('td', {
        key: answer.id
      }, [(q.type === 1 && !_vm.displayErrors) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.picked[idx]),
          expression: "picked[idx]"
        }],
        staticClass: "css-radio",
        attrs: {
          "type": "radio",
          "name": 'answer' + q.id,
          "id": 'answer' + answer.id
        },
        domProps: {
          "value": answer.id,
          "checked": _vm._q(_vm.picked[idx], answer.id)
        },
        on: {
          "change": function($event) {
            return _vm.$set(_vm.picked, idx, answer.id)
          }
        }
      }) : _vm._e(), _vm._v(" "), (q.type !== 1 && !_vm.displayErrors) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.test),
          expression: "test"
        }],
        staticClass: "css-checkbox",
        attrs: {
          "type": "checkbox",
          "name": 'answer' + q.id,
          "id": 'answer' + answer.id
        },
        domProps: {
          "value": answer.id,
          "checked": Array.isArray(_vm.test) ? _vm._i(_vm.test, answer.id) > -1 : (_vm.test)
        },
        on: {
          "click": function($event) {
            return _vm.pick(answer.id, idx)
          },
          "change": function($event) {
            var $$a = _vm.test,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = answer.id,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.test = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.test = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.test = $$c
            }
          }
        }
      }) : _vm._e(), _vm._v(" "), (!_vm.displayErrors) ? _c('label', {
        staticClass: "css-label",
        attrs: {
          "for": 'answer' + answer.id
        }
      }, [_vm._v(_vm._s(answer.content))]) : _vm._e(), _vm._v(" "), (q.type === 1 && _vm.displayErrors) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.picked[idx]),
          expression: "picked[idx]"
        }],
        staticClass: "css-radio",
        attrs: {
          "type": "radio",
          "name": 'answer' + q.id,
          "id": 'answer' + answer.id,
          "disabled": ""
        },
        domProps: {
          "value": answer.id,
          "checked": _vm._q(_vm.picked[idx], answer.id)
        },
        on: {
          "change": function($event) {
            return _vm.$set(_vm.picked, idx, answer.id)
          }
        }
      }) : _vm._e(), _vm._v(" "), (q.type !== 1 && _vm.displayErrors) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.test),
          expression: "test"
        }],
        staticClass: "css-checkbox",
        attrs: {
          "type": "checkbox",
          "name": 'answer' + q.id,
          "id": 'answer' + answer.id,
          "disabled": ""
        },
        domProps: {
          "value": answer.id,
          "checked": Array.isArray(_vm.test) ? _vm._i(_vm.test, answer.id) > -1 : (_vm.test)
        },
        on: {
          "click": function($event) {
            return _vm.pick(answer.id, idx)
          },
          "change": function($event) {
            var $$a = _vm.test,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = answer.id,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.test = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.test = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.test = $$c
            }
          }
        }
      }) : _vm._e(), _vm._v(" "), (_vm.displayErrors) ? _c('label', {
        class: answer.correct === 0 ? 'css-label-wrong' : 'css-label',
        attrs: {
          "for": 'answer' + answer.id
        }
      }, [_vm._v(_vm._s(answer.content))]) : _vm._e()])
    }), 0)])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "valider"
  }, [(_vm.invalid) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("Vous n'avez pas coché toutes les réponses !")]) : _vm._e(), _vm._v(" "), (!_vm.displayErrors) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.sendAnswers()
      }
    }
  }, [_vm._v("Valider")]) : _vm._e(), _vm._v(" "), (!_vm.displayErrors) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.clean()
      }
    }
  }, [_vm._v("Réinitialiser")]) : _vm._e(), _vm._v(" "), (_vm.displayErrors) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.clean()
      }
    }
  }, [_vm._v("Recommencer")]) : _vm._e(), _vm._v(" "), (_vm.displayErrors) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.closeQuestionnaire()
      }
    }
  }, [_vm._v("Quitter")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        return _vm.closeQuestionnaire()
      }
    }
  })])], 2)])])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.showQuestionnaireFeedback) ? _c('div', [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container quizz"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Questionnaire")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(this.winning) ? _c('p', [_vm._v("Félicitations ! Vous avez completé le questionnaire avec toute les bonnes réponses")]) : _c('p', [_vm._v("Certaines réponses sont incorrectes. Cliquez sur 'Ok' pour voir vos mauvaises réponses")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.closeFeedback()
      }
    }
  }, [_vm._v("Ok")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        return _vm.closeFeedback()
      }
    }
  })])], 2)])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.showQuestionnaireResults) ? _c('div', [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container quizz"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Résultats")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("En développement.")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.result = false
      }
    }
  }, [_vm._v("Ok")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.result = false
      }
    }
  })])], 2)])])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e06e2a54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Category.vue
// module id = 457
// module chunks = 1